var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.active
    ? _c(
        "Modal",
        { attrs: { title: _vm.fileName }, on: { close: _vm.close } },
        [
          _c("EditorWrapper", {
            attrs: {
              "file-id": _vm.fileId,
              "relative-path": _vm.relativePath,
              active: _vm.active,
              "share-token": _vm.shareToken,
              mime: _vm.mimeType
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }